import { Facebook, Linkedin, Twitter } from '@/components/ui/atoms/brand'
import { Button } from '@/components/ui/atoms/button'
import Whatsapp from '@/components/ui/atoms/whatsapp'
import { copyToClipboard } from '@/lib/client'
import { LinkIcon } from 'lucide-react'

export default function ShareButtons({
  source,
  link,
  title,
}: {
  source?: string
  link?: string
  title?: string
}) {
  const handleClick = (_ev: React.MouseEvent<HTMLElement>) => {
    //ev.stopPropagation() ||
    copyToClipboard(`${link}`)
  }

  return (
    <div className="flex flex-col md:flex-row gap-3 mb-4">
      <span className="font-semibold text-sm items-center flex">{source}</span>
      <div className="flex gap-x-3">
        <Button
          variant="default"
          size="icon"
          className="rounded-full bg-sky-50 text-sky-700 ring-1 ring-inset ring-sky-600/10 hover:bg-sky-100 hover:text-sky-700"
          asChild
        >
          <a
            href={`https://web.whatsapp.com/send?text=${title} ${link}`}
            target="_blank"
            aria-label="compartilhe-whatsapp"
            rel="noreferrer"
          >
            <Whatsapp />
          </a>
        </Button>
        <Button
          variant="default"
          size="icon"
          className="rounded-full bg-sky-50 text-sky-700 ring-1 ring-inset ring-sky-600/10 hover:bg-sky-100 hover:text-sky-700"
          asChild
        >
          <a
            href={`https://www.facebook.com/share.php?u=${link}`}
            target="_blank"
            aria-label="compartilhe-facebook"
            rel="noreferrer"
          >
            <Facebook className="h-4 w-4" />
          </a>
        </Button>
        <Button
          variant="default"
          size="icon"
          className="rounded-full bg-sky-50 text-sky-700 ring-1 ring-inset ring-sky-600/10 hover:bg-sky-100 hover:text-sky-700"
          asChild
        >
          <a
            href={`https://www.linkedin.com/shareArticle?mini=true&url=${link}/&title=${title}`}
            target="_blank"
            aria-label="compartilhe-linkedin"
            rel="noreferrer"
          >
            <Linkedin className="h-4 w-4" />
          </a>
        </Button>
        <Button
          variant="default"
          size="icon"
          className="rounded-full bg-sky-50 text-sky-700 ring-1 ring-inset ring-sky-600/10 hover:bg-sky-100 hover:text-sky-700"
          asChild
        >
          <a
            href={`https://twitter.com/intent/tweet?text=${title}!&url=${link}`}
            target="_blank"
            aria-label="compartilhe-x"
            rel="noreferrer"
          >
            <Twitter className="h-4 w-4" />
          </a>
        </Button>
        <Button
          variant="default"
          size="icon"
          aria-label="Compartilhar Link"
          className="rounded-full bg-sky-50 text-sky-700 ring-1 ring-inset ring-sky-600/10 hover:bg-sky-100 hover:text-sky-700"
          onClick={handleClick}
        >
          <LinkIcon className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
